var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import ElementController from "../base-controllers/ElementController.js";
import { value } from "../base-controllers/element_controller/value_decorator.js";
import { getOrPresentMessage } from "../global-controllers/messages/utils.js";
import { copyText } from "../utils/clipboard.js";
import { gettext } from "../utils/i18n.js";
/**
 * Copy a text to clipboard on click.
 *
 * @example
 *
 * <button data-controller="ClipboardText" data-text="A text">
 *   ...
 */
class ClipboardText extends ElementController {
    constructor() {
        super(...arguments);
        this.handleClick = async () => {
            if (!this.text) {
                throw new Error("ClipboardText is missing `data-text`");
            }
            if (await copyText(this.text)) {
                await getOrPresentMessage("success", this.message || gettext("Copied"));
            }
        };
    }
}
ClipboardText.id = "ClipboardText";
ClipboardText.binds = {
    root: [["click", "handleClick"]],
};
export default ClipboardText;
__decorate([
    value(String)
], ClipboardText.prototype, "text", void 0);
__decorate([
    value(String)
], ClipboardText.prototype, "message", void 0);
//# sourceMappingURL=ClipboardText.js.map